/*
Loons Lab Date picker component
Developed By Roshan
Loons Lab
*/
import React, { Component } from "react";
import { Card } from '@material-ui/core'
import { any } from "prop-types";

class LoonsCard extends Component {
    static propTypes = {
        title: any,
        style: any,
        children: Node,
    };

    static defaultProps = {
        title: null,

    };



    render() {
        const {
            title,
            children,
            style
        } = this.props;


        return (

            <Card elevation={6} style={style} className="px-4 py-4">
                {children}
            </Card>


        );
    }
}

export default LoonsCard;